import * as React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {toggle} from 'opticks/lib/optimizely'

import {BrandType} from '@daedalus/core/src/brand/types'

interface BrandLogoProps {
  /** Which brand's logo to display */
  brand: BrandType
  /** Whether to display the compact version */
  compact?: boolean
  /** Sets the height of the img element. Defaults to 100% */
  height?: string
}

const LogoImageElement = styled('img')<{customHeight?: string}>(
  ({customHeight}) => css`
    display: block;
    margin: 0 auto;
    height: ${customHeight ?? '100%'};
    max-width: 100%;
    width: auto;
  `
)

const getBrandLogo = (brand: BrandType, compact = false): string => {
  // TODO - When we have SVGs for all logos, remove the condition and try to
  // only use brand.code in the URL.
  if (brand.code === 'etrip') {
    return compact
      ? require('../../../foundation/logos/brandLogo/etrip-logo-compact.svg')
      : require('../../../foundation/logos/brandLogo/etrip-logo.svg')
  }

  if (brand.code === 'vio') {
    return require('../../../foundation/logos/brandLogo/vio-logo.svg')
  }

  return compact
    ? require('../../../foundation/logos/brandLogo/findhotel-logo-compact.svg')
    : toggle(
        'dq82hd-desktop-map',
        () => require('../../../foundation/logos/brandLogo/findhotel-logo.svg'),
        () =>
          require('../../../foundation/logos/brandLogo/findhotel-logo-b.svg')
      )
}

const BrandLogo = (props: BrandLogoProps) => {
  const {brand, compact, height} = props

  return (
    <LogoImageElement
      customHeight={height}
      src={getBrandLogo(brand, compact)}
      alt={brand.name}
      title={brand.name}
    />
  )
}

export default BrandLogo
